import CONSTANTS from '../const';
import { windowModeEnum } from '../enums'
// accepts device and orientation options and returns it
// in a structure compatible with spanning-css-polyfill
export default function upadter ({ orientation, deviceType, windowMode }) {
  let foldSize = CONSTANTS[deviceType].foldSize;
  let browserShellSize = CONSTANTS[deviceType].browserShellSize;
  let spanning;
  if( windowMode !== windowModeEnum.spanning ) {
    spanning = 'none'
    return { spanning, foldSize, browserShellSize }
  }
  if( orientation === 'portrait' ) {
    spanning  = 'single-fold-horizontal'
  } else {
    spanning  = 'single-fold-vertical'
  }
  console.log(browserShellSize)
  return { spanning, foldSize, browserShellSize }
}